import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-inquiry-deeplink',
  imports: [MatProgressSpinner],
  templateUrl: './inquiry-deeplink.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './inquiry-deeplink.component.scss',
})
export class InquiryDeeplinkComponent {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
    this.router.navigate(['/cases', this.route.snapshot.params['id']]);
  }
}
